export const makeTestIncident = (user, now = new Date()) => ({
  id: "test-1",
  imei: "Test vehicle",
  vehicle_name: "Truck 12",
  current_vehicle_name: "Truck 12",
  status: "unacknowledged",
  activated_at: now.toISOString(),
  last_activation_at: now.toISOString(),
  detected_at: now.toISOString(),
  input_value: 1,
  input_observed_at: now.toISOString(),
  activation_count: 1,
  version: 1,
  activation_location: { lat: -37.8136, lon: 144.9631 },
  activation_location_at: now.toISOString(),
  last_signal_location: { lat: -37.8136, lon: 144.9631 },
  latest_location: { lat: -37.8136, lon: 144.9631 },
  latest_location_at: now.toISOString(),
  owner_id: null,
  owner_name: null,
  deliveries: [],
  driver: null,
  events: [
    { id: 1, type: "activated", occurred_at: now.toISOString(), detail: {} },
  ],
});
export function testAction(incident, action, user, { note } = {}) {
  const time = new Date().toISOString(),
    next = {
      ...incident,
      version: incident.version + 1,
      events: [...incident.events],
    };
  if (action === "resolve") {
    if (
      incident.owner_id !== user.username_id ||
      incident.input_value !== 0 ||
      !note?.trim()
    )
      throw new Error(
        "Take control, release the button and add a note before resolving."
      );
    Object.assign(next, {
      status: "resolved",
      resolved_at: time,
      resolution_note: note.trim(),
    });
  } else
    Object.assign(next, {
      status: "acknowledged",
      owner_id: user.username_id,
      owner_name: `${user.first_name || "Test"} ${
        user.last_name || "operator"
      }`,
      claimed_at: time,
    });
  next.events.push({
    id: next.events.length + 1,
    type:
      action === "resolve"
        ? "resolved"
        : action === "takeover"
        ? "taken_over"
        : "claimed",
    occurred_at: time,
    actor_name: next.owner_name,
    detail: { note },
  });
  return next;
}
export function testInput(incident, value) {
  if (incident.status === "resolved") return incident;
  const time = new Date(
    Math.max(Date.now(), new Date(incident.input_observed_at).getTime() + 1)
  ).toISOString();
  const next = {
    ...incident,
    input_value: value,
    input_observed_at: time,
    version: incident.version + 1,
    events: [...incident.events],
  };
  if (value !== incident.input_value) {
    if (value === 1) {
      next.last_activation_at = time;
      next.activation_count += 1;
    }
    next.events.push({
      id: next.events.length + 1,
      type: value ? "repeat_activation" : "released",
      occurred_at: time,
      detail: {},
    });
  }
  return next;
}
